export default {
  addOns: '추가 항목',
  availability: '가용성',
  availabilityDaySelector: '예약 가능 날짜 선택기',
  unavailable: '사용 불가',
  person: '사람',
  people: '사람들',
  reserveNow: '지금 예약',
  selectTime: '시간 선택',
  select: '선택',
  reserve: '예약',
  time: '시간',
  tier: '등급',
  questions: '질문',
  addToCart: '장바구니에 추가',
  checkout: '결제',
  total: '합계',
  whatsIncluded: '포함된 항목',
  showMore: '더 보기',
  showLess: '덜 보기',
  session: '세션',
  viewDetails: '자세히 보기',
  findAvailability: '가용성 확인',
  loading: '로딩 중',
  capacity: '용량',
  noAvailableSessionsOnThisDate: '이 날짜에 사용할 수 있는 세션이 없습니다',
  noGroupAvailableOnThisDateAndTime:
    '이 날짜와 시간에 {{groupTitle}}을 사용할 수 없습니다',
  noCollectionFound: '컬렉션을 찾을 수 없습니다!',
  noResourceGroupFound: '리소스 그룹을 찾을 수 없습니다!',
  noData: '데이터 없음!',
  continue: '계속',
  night: '박',
  nights: '박',
  noAvailableSessionsForSelectedDates:
    '선택한 날짜 중 일부에 사용 가능한 세션이 없습니다. 다른 날짜를 선택해주세요.',
  from: '부터',
  dateRangeSelector: '날짜 범위 선택기',
  priceTierRadioGroup: '가격 등급 라디오 버튼 그룹',
  startTime: '시작 시간',
  duration: '이용 시간',
  lengthOfStay: '숙박 기간',
  startDate: '시작 날짜',
  endDate: '종료 날짜',
  selectDates: '날짜 선택',
  more: '더보기',
  selectStartTime: '시작 시간 선택',
  endTime: '종료 시간',
  selectEndTime: '종료 시간 선택',
  morning: '오전',
  afternoon: '오후',
  save: '저장',
  selectDuration: '이용 시간 선택',
  forLength: '{{length}} 기준',
  moreDates: '{{count}}개 더',
  addDate: '날짜 추가',
  start: '시작',
  end: '종료',
  pickupFrom: '픽업 시작',
  returnBy: '반납 기한',
  day: '일',
  days: '일',
  hour: '시간',
  hours: '시간',
};
